<!-- 任务分解 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add">新增</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-view" @click="view(scope.row)"/>
          <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"/>
          <el-popover
            :ref="scope.row.billState"
            placement="top"
            width="180"
          >
            <p>确定退回该任务分解单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.billState].doClose()">取消</el-button>
              <!-- <el-button type="primary" size="mini" @click="audit(scope.row)">确定</el-button> -->
            </div>
            <el-button type="text" size="mini" icon="el-icon-back" slot="reference"></el-button>
          </el-popover>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
        <template #icon="row">
          <svg-icon :icon-class="row.icon"/>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
  import '@/components/EditDataTable';
  import DynamicSearch from '@/components/DynamicSearch';
  import DataTableMixin from '@/mixins/DataTableMixin';
  import '@/components/dynamic-form';
  import { del, reviewTask } from '@/api/bill/taskDecomposition'
  import { tableSataus } from '@/views/bill/mixins/status'
  import { parseTime } from "@/utils"

  export default {
    name: 'Achievement',
    directives: {},
    filters: {},
    mixins: [DataTableMixin, tableSataus],
    components: { DynamicSearch },
    data() {
      return {
        delLoading: false,
        supThis: this,
        isAdd: false,
        tableHead: [
          {
            prop: 'code',
            label: '单据编号',
          },
          {
            prop: 'bsProject.code',
            label: '项目号',
            query: {
              type: 'input'
            }
          },
          {
            formatter: this.formatter,
            prop: 'commitTime',
            label: '提交日期',
          },
          {
            prop: 'bsMilestoneNode.name',
            label: '项目阶段',
          },
          {
            prop: 'bsProjectNode.name',
            label: '计划节点',
          },
          {
            prop: 'projectNodeCode',
            label: '计划节点编号',
          },
          {
            formatter: this.formatter,
            prop: 'expectedStartTime',
            label: '预计开始时间',
          },
          {
            formatter: this.formatter,
            prop: 'expectedEndTime',
            label: '期望完成日期',
          },
          {
            prop: 'completionStatus',
            label: '完成情况',
            formatter: (status) => {
              return this.statusFormatter(status)
            },
          },
          {
            prop: 'remark',
            label: '备注'
          },
          {
            label: "状态",
            prop: "billState",
            formatter: (state) => {
              return this.statusName(state)
            }
          },
        ],
      }
    },
    created() {
      // 列表数据初始化
      this.$nextTick(() => {
        this.dataTableInit()
      });
    },
    methods: {
      formatter(val) {
        if (val) {
          const date = new Date(val)
          return parseTime(date,"{y}-{m}-{d}")
        }
      },
      statusFormatter(status) {
        if (status === 'Y') {
          return '已完成'
        } else if (status === 'N') {
          return '未完成'
        } else {
          return ''
        }
      },
      dataTableBeforeInit() {
        this._url = '/bizTaskDecomposition/findList'
        const params = {current: this.page, size: this.offset}
        this._params = Object.assign(params, this._query)
        return true
      },
      subDelete(id) {
        this.delLoading = true;
        del(id).then(res => {
          this.delLoading = false
          this.$refs[id].doClose()
          this.dataTableInit()
          this.$notify({
            title: '删除成功',
            type: 'success',
            duration: 2500
          })
        }).catch(err => {
          this.delLoading = false
          this.$refs[id].doClose()
          console.log(err)
        })
      },
      audit(data) { // 审核
        this.updata({ id: data.id, billState: 3 })
        this.$refs[data.billState].doClose()
      },
      updata(data) {
        reviewTask(data).then(res => {
          if (res.code === 200) {
            this.$notify({
              title: "审核成功",
              type: "success",
              duration: 2500
            });
            this.dataTableInit()
          }
        });
      },
      edit(row) {
        this.$router.push({path: "taskDecomposition/form" ,query: { id: row.id, isEdit: true}})
      },
      view(row) {
        this.$router.push({path: "taskDecomposition/form" ,query: { id: row.id, isEdit: false}})
      },
      add() {
        this.$router.push({path: "taskDecomposition/form" ,query: { isEdit: true }})
      },
    }
  }
</script>

<style scoped>
  .btn {
    border: none;
    padding: 0;
  }
</style>
